/*
 * @Author: lzy
 * @Date: 2020-05-19 17:12:18
 * @LastEditors: DQL
 * @LastEditTime: 2020-09-09 10:13:58
 * @Description: file content
 */
import axios from 'axios';
import config from '@/config';

const commontCtx = config.commontCtx;

// 获取扩展字段--用户
export const attrUser = () => { return axios.get(`${commontCtx}/attr/user`); };

// 获取扩展字段--身份
export const attrCapacity = () => { return axios.get(`${commontCtx}/attr/capacity`); };

// 获取扩展字段--机构
export const attrDept = () => { return axios.get(`${commontCtx}/attr/dept`); };
